export function validate(data, valueSchema, errors = []) {
  const result = getResultStructure(data);

  for (const key in data) {
    const parsed = valueSchema.safeParse(data[key]);

    if (parsed.success) {
      result[key] = parsed.data;
    } else {
      const path = parsed.error.errors[0].path.join('.') || '?';
      const message = parsed.error.errors[0].message || 'Invalid';
      errors.push(`${key}.${path}: ${message}`);
    }
  }
  return result;
}

function getResultStructure(data) {
  if (data instanceof Array) {
    return [];
  }
  if (data instanceof Object) {
    return {};
  }
  throw 'Invalid type';
}
